const FontsData = {
  fonts: [
    {
        font: 'Mochary Bold',
        fontName: 'Madison',
        url: "https://www.etsy.com/listing/670405442/wooden-baby-name-sign-personalized?ref=some_etsy_variable_1"
    },
    {
      font: 'Gadimon',
      fontName: 'Jade',
      url: "https://www.etsy.com/listing/670405442/wooden-baby-name-sign-personalized?ref=some_etsy_variable_1"
    },
    {
        font: 'Lavanderia Sturdy',
        fontName: 'Scarlett',
        url: "https://www.etsy.com/listing/670405442/wooden-baby-name-sign-personalized?ref=some_etsy_variable_1"
    },
    {
        font: 'Pacifico',
        fontName: 'Elwood',
        url: "https://www.etsy.com/listing/670405442/wooden-baby-name-sign-personalized?ref=some_etsy_variable_1"
    },
    {
      font: 'Hoodson Script',
      fontName: 'Chandler',
      url: "https://www.etsy.com/listing/670405442/wooden-baby-name-sign-personalized?ref=some_etsy_variable_1"
    }
  ]
};

export default FontsData;



// WEBPACK FOOTER //
// ./src/app/Content/assets/fontsData.js